import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  primaryAction: `ChoicePrimaryAction`,
  result: `ChoiceResult`,
  root: `ChoiceRoot`,
  secondaryAction: `ChoiceSecondaryAction`
};

export function useChoiceStyles() {
  const { semanticColors } = useTheme();

  const choiceStyles = useMemo(
    () => mergeStyleSets({
      result: [
        classNames.result,
        {
          width: `calc(100% - 25px)`
        }
      ],
      root: [
        classNames.root,
        {
          overflow: `hidden`,
          width: `100%`
        }
      ],
      primaryAction: [
        classNames.primaryAction,
        {
          paddingLeft: `10px`,
          "& button": {
            border: 0,
            height: `100%`,
            minWidth: `25px`,
            padding: 0,
            color: semanticColors.disabledSubtext,
            backgroundColor: semanticColors.buttonBackgroundHovered
          },
          [`.${classNames.root}:hover & button`]: {
            backgroundColor: semanticColors.primaryButtonBackground,
            color: semanticColors.primaryButtonText
          },
          ".ms-ChoiceField-field.is-checked & button": {
            backgroundColor: semanticColors.primaryButtonBackground,
            color: semanticColors.primaryButtonText
          },
          [`.ms-ChoiceField-field.is-checked .${classNames.root}:hover & button`]: {
            backgroundColor: semanticColors.primaryButtonBackgroundHovered,
            color: semanticColors.primaryButtonTextHovered
          }
        }
      ],
      secondaryAction: [
        classNames.secondaryAction,
        {
          "& button": {
            backgroundColor: `transparent`,
            border: 0,
            height: `100%`,
            minWidth: `25px`,
            padding: 0,
            color: semanticColors.disabledSubtext
          },
          "& button > span > i": {
            color: semanticColors.primaryButtonBackground
          }
        }
      ]
    }),
    [semanticColors]
  );

  const gridStyles = useMemo(
    () => mergeStyleSets({
      label: {
        width: `125px`
      },
      headerWrap: {
        height: 0,
        padding: 0,
        margin: 0
      }
    }),
    []
  );

  return {
    choiceStyles,
    gridStyles
  };
}
